import { z } from "zod";
/**
 * Expense category is "a config-driven category list, not a hardcoded enum"
 * (Phase 7 task brief), mirroring `vaccine-type.ts`'s own reasoning for
 * vaccine type: modeled as a validated code string rather than a Zod
 * `z.enum` (which would require a code change/migration to add a category)
 * and as rows in `stable_expense_categories`, not a Postgres CHECK-enum
 * column (`packages/database/AGENTS.md`: "Use PostgreSQL enums only for
 * genuinely stable closed sets" — expense categories are explicitly not
 * one; `docs/products/stable.md` "Accounting": "Feed, Stable Supplies,
 * Horse Care Supplies, etc." is illustrative, not exhaustive).
 */
export const ExpenseCategoryCodeSchema = z
    .string()
    .regex(/^[A-Z][A-Z0-9_]{1,49}$/, "category must be an uppercase code, e.g. STABLE_SUPPLIES.");
export const ExpenseCategoryConfigSchema = z
    .object({
    code: ExpenseCategoryCodeSchema,
    label: z.string().trim().min(1).max(120),
})
    .strict();
export function isKnownExpenseCategory(registry, code) {
    return Object.hasOwn(registry, code);
}
